// extracted by mini-css-extract-plugin
export default {"slots-category":"lottery_slots-category__ANInQ","category-tab":"lottery_category-tab__7wXt9"};